export const getPendingCvReviewPath = (locale: string) =>
  `/${locale}/dashboard/review/pending`;

export const isPendingCvReviewPath = (path: string) => {
  const { pathname } = new URL(path, "http://localhost");
  return /^\/[^/]+\/dashboard\/review\/pending\/?$/.test(pathname);
};
